import React, { useEffect, useState } from 'react';
import { Marker } from 'react-map-gl';
import { useSelector } from 'react-redux';

export default function ListingCluster({ cluster, onClick }) {
  const [longitude, latitude] = cluster.geometry.coordinates;
  const [isHighlighted, setIsHighlighted] = useState(false);
  const { highlightedFeature } = useSelector((state) => state.map);

  useEffect(() => {
    setIsHighlighted(highlightedFeature === `cluster-${cluster.id}`);
  }, [highlightedFeature]);

  return (
    <Marker
      longitude={longitude}
      latitude={latitude}
      offsetLeft={-26}
      offsetTop={-26}
    >
      <div className={`cluster ${isHighlighted ? 'highlighted' : ''}`} onClick={() => { onClick(cluster); }}>
        <div>{cluster.properties.point_count}</div>
      </div>
    </Marker>
  );
}
